export function getSolveColumns() {
    return [
        { field: "id", headerName: "ID", flex: 1 },
        { field: "name", headerName: "User", flex: 1 },
        { field: "wordWheelTitle", headerName: "Title", flex: 1 },
        { field: "startedAt", headerName: "Started", flex: 0.8 },
        { field: "finishedAt", headerName: "Finished", flex: 0.8 },
        {
            field: "percentage",
            headerName: "Percentage",
            flex: 0.6,
            renderCell: (params) => `${params.value ?? 0}%`,
        },
        {
            field: "isCompleted",
            headerName: "Completed",
            flex: 0.6,
            renderCell: (params) => (params.value ? "Yes" : "No"),
        },
        { field: "attemptsCount", headerName: "Attempts", flex: 0.5 },
    ];
}
